export default __webpack_public_path__ + "static/media/autofarm.3267b759.svg";